// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //apiBaseUrl: 'http://localhost:8080',
  //apiBaseUrl: 'http://localhost:8084',
  //apiBaseUrl: 'http://localhost:8088',
  //apiBaseUrl: 'http://smc.dev.zaruc.com.br:8080',
  apiBaseUrl: 'http://smc.zaruc.srv.br:8080',
  expiryDate: '2024-12-31'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
